export function setCookie(name: string, value: string, hours: number, domain: string) {
  const date = new Date();
  date.setTime(date.getTime() + hours * 60 * 60 * 1000);
  const expires = "; expires=" + date.toUTCString();

  document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=" + domain;
}

export function getCookie(name: string): string | null {
  const cookies = document.cookie.split(";");
  const items = cookies.filter((c) => c.split("=")[0].trim() == name);
  return items.length > 0 ? items[0].split("=")[1].trim() : null;
}
